// @flow
import { Form } from '@duxton-web/ui';
import React, { useEffect } from 'react';

import Toastr from 'omega-rtc/utils/toastr-util';
import './LoginPage.scss';

type Props = {
  handleSuccessfulLogin: Function,
};

export function GoogleForm({ handleSuccessfulLogin }: Props) {
  const handleCredentialResponse = (response) => {
    if (response.error) {
      Toastr.error(`Login Failed.Error : ${response.error}`);
      return;
    }

    const jwt = response.credential;
    handleSuccessfulLogin(jwt);
  };

  useEffect(() => {
    // Load Google Sign-In library dynamically
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    document.body.appendChild(script);

    // Initialize Google Sign-In Function
    window.handleCredentialResponse = handleCredentialResponse;
  });

  return (
    <Form>
      <div
        id="g_id_onload"
        data-client_id={window.Grab.config.GOOGLE_AUTH_CLIENT_ID}
        data-context="signin"
        data-ux_mode="popup"
        data-callback="handleCredentialResponse"
        data-auto_prompt="false"
      />

      <div
        className="g_id_signin"
        data-type="standard"
        data-shape="rectangular"
        data-theme="outline"
        data-text="Login with Google"
        data-size="large"
        data-logo_alignment="left"
      />
    </Form>
  );
}

export default GoogleForm;
